/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';
import jwt from 'jsonwebtoken';
import PropTypes from 'prop-types';
import questionBg from '../../template/utils/images/questionBg.png';
import WithDrawSavingOption from './WithDrawSavingOptions';
import withdrawTargetSaving, { deleteWithdrawTargetSavingError } from '../../actions/savings.actions/withdrawTargetSavings';
import { ErrorAlertNotification } from '../commons/index';

/**
 * @class WithDrawSavings
 */
class WithDrawSavingsModal extends Component {
  onWithdrawSavings = () => {
    const getSavingObj = Cookie.getJSON('savingObj');
    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;
    const { WithdrawTargetSaving } = this.props;

    if (getSavingObj.planType === 'PERSONAL_TARGET_SAVINGS' || getSavingObj.planType === 'GROUP_TARGET_SAVINGS') {
      const targetSavingObj = {
        customerId,
        targetSavingsId: getSavingObj.id
      };
      WithdrawTargetSaving(targetSavingObj);
    }
  }

  handleDelete = () => {
    const savingActionType = Cookie.getJSON('savingObj');
    const actualSavingObj = savingActionType || '';
    if (actualSavingObj.planType === 'PERSONAL_TARGET_SAVINGS' || actualSavingObj.planType === 'GROUP_TARGET_SAVINGS') {
      const {
        DeleteWithdrawTargetSavingError
      } = this.props;
      DeleteWithdrawTargetSavingError();
    }
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const check = Cookie.get('savingCheck');
    const {
      WithdrawTargetSavingsLoading,
      WithdrawTargetSavingsError,
    } = this.props;
    const withDrawSavings = (
      <div className="modal fade" id="meep_settings">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                {' '}
                <span> Close </span>
                {' '}
&times;
              </button>
            </div>

            <div className="modal-body p-5">
              <div className="first_step">
                <div className="ques_info">
                  <img src={questionBg} alt="" />
                </div>

                {
                  WithdrawTargetSavingsError ? (
                    <ErrorAlertNotification
                      errors={WithdrawTargetSavingsError}
                      onClick={this.handleDelete}
                    />
                  ) : ''
                }

                <div className="have_stock_acc">
                  <p>
                        Would you like to withdraw ?
                  </p>
                </div>

                <div className="have_stock_acc_answer">

                  <div className="ans_no">
                    <button
                      type="button"
                      data-dismiss="modal"
                    >
                      No I Dont
                    </button>
                  </div>

                  <div className="ans_yes">
                    {
                      check === 'PERSONAL_TARGET_SAVINGS' || check === 'GROUP_TARGET_SAVINGS' ? (
                        <button
                          type="button"
                          onClick={this.onWithdrawSavings}
                        >
                          {
                          WithdrawTargetSavingsLoading ? (
                            <i className="fa fa-spinner fa-spin" />
                          ) : ''
                        }
                          <span style={{ color: 'white' }}>Yes I Do</span>
                        </button>
                      ) : (
                        <button
                          type="button" id="yes_i_do"
                          onClick={this.onWithdrawSavings}
                          data-toggle="modal"
                          data-target="#ftop_settings"
                          data-dismiss="modal"
                        >
                          <span style={{ color: 'white' }}>Yes I Do</span>
                        </button>
                      )
                    }
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return (
      <>
        {withDrawSavings}
        {
          check === 'PERSONAL_TARGET_SAVINGS' ? '' : (
            <WithDrawSavingOption />
          )
        }
      </>
    );
  }
}

WithDrawSavingsModal.propTypes = {
  WithdrawTargetSaving: PropTypes.func,
  DeleteWithdrawTargetSavingError: PropTypes.func,
  WithdrawTargetSavingsLoading: PropTypes.bool,
  WithdrawTargetSavingsError: PropTypes.any,
};

const mapStateToProps = state => ({
  withDrawFixSavingsLoading: state.WithdrawFixedSavings.loading,
  withDrawFixSavingsError: state.WithdrawFixedSavings.error,
  WithdrawTargetSavingsLoading: state.WithdrawTargetSavings.loading,
  WithdrawTargetSavingsError: state.WithdrawTargetSavings.error,
});

export default connect(mapStateToProps, {
  WithdrawTargetSaving: withdrawTargetSaving,
  DeleteWithdrawTargetSavingError: deleteWithdrawTargetSavingError
})(WithDrawSavingsModal);
